var _require = require('scratchlink-projects-data/constants'),
    BLOCK_LEVEL_TYPES = _require.BLOCK_LEVEL_TYPES,
    PROJECT_TYPES = _require.PROJECT_TYPES;

var ScratchEbotEmptyProject = 'ScratchEbotEmptyProject';
var ScratchComingSoonProject = 'ScratchComingSoonProject';
module.exports = {};